export const centsToDollars = (cents) => {
  let dollars = (cents / 100).toFixed(2);
  return "$" + dollars.replace(/\d(?=(\d{3})+\.)/g, "$&,");
}
